// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"new-search_searchWrapper__hoBIq","filtersActions":"new-search_filtersActions__wfxGd","viewAllBtn":"new-search_viewAllBtn__hdAJW"};